import axios from 'axios'
import React, { createContext, useEffect, useState } from "react";
import { BsBoxFill } from "react-icons/bs";
import { BsCartFill } from "react-icons/bs";
import { BsDatabaseFill } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
export const GetUserContext = createContext();

export const GetUserContextProvider = ({ children }) => {
    const [userDatas, setUserDatas] = useState({});
    const [profileData, setProfileData] = useState({});
    const [myContext, setMyContext] = useState();
    const [conjIdHome, setConjIdHome] = useState(1);
    const [pageIsLogin, setPageIsLogin] = useState(false);
    const [registerYourSelf, setRegisterYourSelf] = useState(false);
    const [token, setToken] = useState(localStorage.getItem("token"));
    let axiosConfig = { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    const [loadData, setLoadData] = useState(false);
    const [load, setLoad] = useState(false)
    const [qtdTotal, setqtdTotal] = useState('');
    const [products, setProducts] = useState([])
    const [originalProducts, setOriginalProducts] = useState([]);
    const [fetchTimestamp, setFetchTimestamp] = useState(Date.now());
    const [fetchTimestampApp, setFetchTimestampApp] = useState(Date.now());
    const [qtdCar, setQtdCar] = useState(1)
    const [isReposit, setInsReposit] = useState(false)
    const [prodsCar, setProdsCar] = useState([] || null);
    const [filterEstoque, setFilterEstoque] = useState(false)
    const [ordenarPreco, setOrdenarPreco] = useState(1)
    const [fabricanteArray, setFabricanteArray] = useState([])

    const [nomePeca, setNamePeca] = useState('');
    const [selectedBrands, setSelectedBrands] = useState('');
    const [selectedNames, setSelectedNames] = useState('');
    const [selectedModels, setSelectedModels] = useState('');
    const [selectedAllYears, setSelectedAllYears] = useState('');
    const [selectedEnginer, setSelectedEnginer] = useState('');
    const [selectedEnginerConfig, setSelectedEnginerConfig] = useState('');
    const [selectedFabricante, setSelectedFabricante] = useState('');
    const [page, setPage] = useState(0)
    const take = 50
    const [show, setShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [financeiro, setFinanceiro] = useState([])
    const [dataInicial, setDataInicial] = useState('');
    const [dataFinal, setDataFinal] = useState('');
    const [habilityEntrega, setHabilityEntrega] = useState(false)
    const [activedPagination, setActivedPagination] = useState(false)
    const getCategory = (width) => {
        if (width < 400) return 'xsmall';
        if (width < 576) return 'small';
        if (width < 720) return 'mid-small';
        if (width < 992) return 'mid';
        if (width < 1200) return 'mid-large';
        if (width < 1400) return 'large';
        return 'xlarge';
    };


    const getSize = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        return {
            width,
            height,
            categoria: getCategory(width),
        };
    };

    const [size, setSize] = useState(getSize());

    useEffect(() => {
        const handleResize = () => setSize(getSize());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const onPageChange = (page) => {
        setCurrentPage(page);
    }
    const sequenceMenus = [
        {
            id: 1, icon: <BsBoxFill />,
            name: "Buscar Peças",
            page: "/home",
            conj: [
                { id: 1, conjName: "Buscar Peça" }
            ]
        },
        {
            id: 2, icon: <BsCartFill />,
            name: "Pedidos",
            page: "/pedidos",
            conj: [
                { id: 1, conjName: "Visão Geral" },

            ]
        },

        {
            id: 3, icon: <BsDatabaseFill />,
            name: "Financeiro",
            page: "/financeiro",
            conj: [
                { id: 1, conjName: "Contas a Pagar" },
                { id: 2, conjName: "Pagamento a vista" },

            ]
        },

        {
            id: 4, icon: <FaUser />,
            name: "Perfil",
            page: "/perfil",
            conj: [
                { id: 1, conjName: "Dados Pessoais" }

            ]
        }

    ]
    const navegationTabs = [
        {
            id: 1,
            theme: "Pedidos",
            tabs: [
                {
                    tab: "Pendentes",
                    content: []
                },

                {
                    tab: "Aprovados",
                    content: []
                },
                {
                    tab: "Faturados",
                    content: []
                },
                {
                    tab: "Enviado",
                    content: []
                },

                {
                    tab: "Finalizados",
                    content: []
                },
                {
                    tab: "Cancelados",
                    content: []
                },
            ],

        }
    ]
    const [navegate, setnavegate] = useState(navegationTabs?.[0])

    return (
        <GetUserContext.Provider value={
            {
                myContext, setMyContext, conjIdHome, setConjIdHome, selectedFabricante,
                setSelectedFabricante, sequenceMenus, pageIsLogin, setPageIsLogin,
                registerYourSelf, setRegisterYourSelf, financeiro, setFinanceiro,
                userDatas, setUserDatas, token, setToken, axiosConfig, profileData,
                setProfileData, products, setProducts, load, setLoad, qtdTotal,
                setqtdTotal, fetchTimestamp, setFetchTimestamp, qtdCar, setQtdCar,
                isReposit, setInsReposit, prodsCar, setProdsCar, originalProducts,
                setOriginalProducts, navegate, filterEstoque, setFilterEstoque,
                ordenarPreco, setOrdenarPreco, currentPage, setCurrentPage, onPageChange,
                totalPages, setTotalPages, nomePeca, setNamePeca, show, setShow,
                selectedBrands, setSelectedBrands, selectedNames, setSelectedNames,
                selectedModels, setSelectedModels, selectedAllYears, setSelectedAllYears,
                selectedEnginer, setSelectedEnginer, selectedEnginerConfig, setSelectedEnginerConfig, take,
                fabricanteArray, setFabricanteArray, fetchTimestampApp, setFetchTimestampApp, loadData,
                setLoadData, dataInicial, setDataInicial, dataFinal, setDataFinal, habilityEntrega,
                setHabilityEntrega, size, page, setPage, activedPagination, setActivedPagination
            }
        } >
            {children}
        </GetUserContext.Provider>
    )
}




